<nav class="navbar navbar-expand-xl navbar-light sticky-top" id="navbar">
  <div class="container d-flex justify-content-between p-0">
    <a class="navbar-brand" href="#">
      <img src="../../../assets/images/Logo.png" alt="">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav" [ngClass]="{'justify-content-center': !isSubscribed}">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link active" routerLink="/home" id="navLink1" routerLinkActive="active">{{"HOME" |
            translate}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="navLink2" routerLink="" fragment="about_hidaya"
            [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active">{{"ABOUT_HEDAYA" |
            translate}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="navLink3" routerLink="" fragment="available_packages"
            [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active">{{"AVAILABLE_PACKAGES"
            | translate}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="navLink4" routerLink="" fragment="faq" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">{{"FAQ" |
            translate}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/privacy-policy" id="navLink4" routerLinkActive="active">{{"PRIVACY_POLICY" |
            translate}}</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" routerLink="/terms-conditions" id="navLink4"
            routerLinkActive="active">{{"TERMS_CONDITIONS" |
            translate}}</a>
        </li>

        <li class="nav-item" *ngIf="isSubscribed">
          <a class="nav-link d-flex gold-color" routerLink="/profile" id="navLink4" routerLinkActive="active">
            <img src="../../../assets/images/profile.svg" alt="" class="profile-icon" *ngIf="router.url != '/profile'">
            <img src="../../../assets/images/profile-active.svg" alt="" class="profile-icon"
              *ngIf="router.url == '/profile'">
            {{"PROFILE_PAGE" | translate}}</a>
        </li>

        <li class="nav-item lang-swither">
          <div class="dropdown">
            <button class="btn d-flex" type="button" id="languageDropdown" data-bs-toggle="dropdown"
              aria-expanded="false" (click)="switchLanguage()">
              <img src="../../../assets/images/switch-lang.svg" alt="">
              <span>{{"LANGUAGE" | translate}}</span>
            </button>
            <!-- <ul class="dropdown-menu" aria-labelledby="languageDropdown">
              <li *ngFor="let lang of languagesItems">
                <button class="dropdown-item" (click)="switchLanguage(lang['code'])">
                  {{ lang.label }}
                </button>
              </li>
            </ul> -->
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>